export default __webpack_public_path__ + "static/media/MadScientists_Keyvisual_2.87814394.jpg";